// extracted by mini-css-extract-plugin
export default {"footer":"footer-styles__footer","link":"footer-styles__link","socialMediaBar":"footer-styles__socialMediaBar"};